export default __webpack_public_path__ + "static/media/OutlineError.21beac8e.svg";